import React, { useRef } from "react";
import { animate, motion } from "framer-motion";
import TypeWriter from "typewriter-effect";

import { BsArrowUpRight,BsChevronDown } from "react-icons/bs";

import me from "../assets/R (2).png";

const Home = () => {
  const animations = {
    h1: {
      initial: {
        x: "-100%",
        opacity: 0,
      },
      whileInView: {
        x: 0,
        opacity: 1,
      },
    },
  };
  
  const clientCount = useRef(null)
  const projectCount = useRef(null)

  const animationClientCount = () =>{
    animate(0,8,{
      duration:1,
      onUpdate:(v)=>clientCount.current.textContent = v.toFixed()
    })
  }
  const animationProjectCount = () =>{
    animate(0,25,{
      duration:1,
      onUpdate:(v)=>projectCount.current.textContent = v.toFixed()
    })
  }
  return (

    <div id="home">
      <section>
        <div>
          <motion.h1 {...animations.h1}>
            Hi, I am <br />
            Deepak Kumar
          </motion.h1>

          <TypeWriter
            options={{
              strings: ["A Developer", "A Designer", "A Creator"],
              autoStart: true,
              loop: true,
              cursor: "",
              wrapperClassName: "typewriterpara",
            }}
          />

          <div>
            <a href="mailto:deepak050897@gmail.com">Hire Me</a>
            <a href="#work">
              Projects <BsArrowUpRight />
            </a>
          </div>

          <article>
            <p>
              +<motion.span whileInView={animationClientCount} ref={clientCount}></motion.span>
            </p>
            <span>Programing Languages</span>
          </article>

          <aside>
            <article>
              <p>
                +<motion.span whileInView={animationProjectCount} ref={projectCount}></motion.span>
              </p>
              <span>Projects Done</span>
            </article>

            <article data-spacial>
              <p>Contact</p>
              <span>deepak050897@gmail.com</span>
            </article>
          </aside>
        </div>
      </section>

      <section>
        <img src={me} alt="dkcoding" />
      </section>
      <BsChevronDown/>
    </div>
  );
};

export default Home;
